'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _register = require('./register');

var _register2 = _interopRequireDefault(_register);

var _Base = require('./Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Factory = function () {
    function Factory() {
        (0, _classCallCheck3.default)(this, Factory);
    }

    (0, _createClass3.default)(Factory, null, [{
        key: 'create',
        value: function create(ModelName, args) {
            var composite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var clear = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            if (!Factory.hasModel(ModelName)) {
                return args;
            }

            try {
                var OriginalModel = Factory.getModel(ModelName);
                var Model = clear ? OriginalModel : (0, _Base2.default)(OriginalModel);

                if (composite && Array.isArray(args)) {
                    return args.map(function (item) {
                        return new Model(item);
                    });
                }
                return new Model(args);
            } catch (error) {
                return args;
                console.log('create model error: ', error);
            }
        }
    }, {
        key: 'getModel',
        value: function getModel(Name) {
            if (Factory.hasModel(Name)) {
                return _register2.default[Name];
            }
        }
    }, {
        key: 'hasModel',
        value: function hasModel(Name) {
            return _register2.default.hasOwnProperty(Name);
        }
    }]);
    return Factory;
}();

exports.default = Factory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/Models/Factory.js
// module id = 259
// module chunks = 0